import { Fade } from "react-awesome-reveal";

export function PoliticaPacientes() {
  return (
    <section className="flex items-center justify-center py-40 max-[1024px]:py-28">
      <div className="container">
        <div className="pt-12 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={200}>
            <h2 className="text-center font-roboto text-3xl font-bold text-purple-950 max-[1024px]:text-center max-[1024px]:text-3xl max-[480px]:text-2xl">
              Política de Privacidade – Pacientes beneficiados pela ONG
              Cabelegria <br />
              Última atualização: <span>27/05/2025</span>
            </h2>
          </Fade>
        </div>
        <div className="pb-4 pt-12 max-[1024px]:pt-6 lg:flex lg:flex-col">
          <Fade delay={250}>
            <p className="pb-4 text-sm font-normal text-purple-950">
              A ONG Cabelegria respeita a privacidade, a dignidade e a segurança
              das informações pessoais das pacientes beneficiadas pela doação de
              perucas. Esta Política de Privacidade visa explicar, de forma
              clara e transparente, como tratamos os dados sensíveis que nos são
              confiados, conforme previsto na{" "}
              <strong>
                Lei Geral de Proteção de Dados Pessoais (LGPD – Lei nº
                13.709/2018).
              </strong>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={300}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>1. Quais dados coletamos das pacientes</strong> <br />
              <br />
              Para confirmar a necessidade da peruca e garantir que o
              atendimento seja realizado de forma justa e responsável, podemos
              coletar os seguintes dados: <br />
              <br />
              <ul className="list-disc pl-6">
                <li>Nome completo</li>
                <li>Documento de identificação</li>
                <li>Endereço para envio (quando aplicável)</li>
                <li>Telefone ou e-mail para contato (quando aplicável)</li>
                <li>
                  <strong>
                    Laudo médico e documento comprobatório de tratamento
                    oncológico ou outra condição de saúde que justifique a perda
                    de cabelo
                  </strong>
                </li>
              </ul>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={350}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>2. Finalidade do uso dos dados</strong> <br />
              <br />
              Os dados coletados são utilizados <strong>
                exclusivamente
              </strong>{" "}
              para:
              <br />
              <br />
              <ul className="list-disc pl-6">
                <li>
                  <strong>
                    Confirmar a necessidade de recebimento da peruca{" "}
                  </strong>{" "}
                  com base no diagnóstico informado;
                </li>
                <li>
                  Entrar em contato com a paciente, caso necessário, para
                  questões logísticas relacionadas à entrega ou escolha da
                  peruca.
                </li>
              </ul>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={400}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>3. Base legal para o tratamento</strong>
              <br /> <br />
              Nos termos da LGPD, o tratamento de dados sensíveis exige{" "}
              <strong>consentimento específico e destacado </strong> ou outra
              base legal compatível.
              <br />
              <br />
              A Cabelegria se baseia nas seguintes hipóteses legais: <br />
              <br />
              <ul className="list-disc pl-6">
                <li>
                  <strong>
                    Consentimento expresso da paciente ou seu responsável legal,{" "}
                  </strong>{" "}
                  para o uso exclusivo da ONG na entrega da peruca;
                </li>
                <li>
                  <strong>
                    Cumprimento de finalidade beneficente e de promoção do
                    bem-estar{" "}
                  </strong>
                  da paciente, conforme artigo 11, inciso II, alínea “b” da
                  LGPD.
                </li>
              </ul>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={300}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>4. Compartilhamento de dados</strong> <br />
              <br />
              <strong>
                <strong>
                  Os dados não são compartilhados com terceiros em hipótese
                  alguma.
                </strong>{" "}
                <br /> São utilizados <strong>apenas internamente</strong> e por
                equipe restrita e autorizada da ONG.
              </strong>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={350}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>5. Segurança dos dados</strong> <br />
              <br />
              <ul className="list-disc pl-6">
                <li>
                  Os dados são armazenados de forma segura e protegida, com
                  controle de acesso.
                </li>
                <li>
                  Apenas pessoas autorizadas da equipe da ONG têm acesso a essas
                  informações.
                </li>
                <li>
                  Adotamos boas práticas de segurança da informação para
                  garantir a integridade, confidencialidade e proteção dos
                  dados.
                </li>
              </ul>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={400}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>6. Tempo de armazenamento</strong> <br />
              <br />
              Os dados são armazenados apenas pelo tempo necessário para a
              verificação da necessidade de doação e entrega da peruca. Após
              esse período,{" "}
              <strong>podem ser excluídos ou anonimizados,</strong> salvo quando
              o armazenamento for necessário por obrigação legal ou legítimo
              interesse com base na missão institucional da ONG.
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={600}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>7. Direitos da paciente (titular dos dados)</strong>{" "}
              <br />
              <br />A paciente (ou seu responsável legal) poderá, a qualquer
              momento: <br />
              <br />
              <ul className="list-disc pl-6">
                <li>Solicitar acesso aos dados coletados;</li>
                <li>Solicitar correção ou atualização dos dados;</li>
                <li>
                  Solicitar a exclusão dos dados pessoais (quando aplicável);
                </li>
                <li>Revogar o consentimento fornecido.</li>
              </ul>
              <br />
              📧 Solicitações podem ser enviadas para:{" "}
              <a href="mailto:privacidade@cabelegria.org">
                <strong>privacidade@cabelegria.org</strong>
              </a>
            </p>
          </Fade>
        </div>
        <div className="border border-b-purple-950" />
        <div className="py-4 max-[1024px]:pt-0 lg:flex lg:flex-col">
          <Fade delay={650}>
            <p className="pb-4 text-sm font-normal text-purple-950 max-[1024px]:pt-4">
              <strong>8. Consentimento</strong> <br />
              <br />
              Ao fornecer seus dados e laudo médico à ONG Cabelegria, a paciente
              ou seu responsável declara estar ciente desta Política de
              Privacidade e{" "}
              <strong>
                autoriza o tratamento dos dados para os fins aqui descritos.
              </strong>
            </p>
          </Fade>
        </div>
      </div>
    </section>
  );
}
